import { cookie, retrieveAndParse, write, makeRandomString } from "../../utilities/Utility";

import {
	writePrecursorXMLSingle,
	writePrecursorXMLLines
} from "../../writes/udo";

export const types = {
	SET_DEFAULT: 'PM/SET_DEFAULT',
	SET_ATTRIBUTE_BY_OBJ: 'PM/SET_ATTRIBUTE_BY_OBJ',
	SET_STATE: 'PM/SET_STATE',
	UPDATE_BP: 'PM/UPDATE_BP',
	ADD_PROJECT: 'PM/ADD_PROJECT',
	ADD_PHASE: 'PM/ADD_PHASE',
	ADD_TASK_GROUP: 'PM/ADD_TASK_GROUP',
}

const defaultState = {
	loading: false,
	currentBP: null,
	currentProj: null,
	currentInvoice: null,
	currentPhase: null,
	currentTaskGroup: null,
	currentUser: null,
	currentUserIndex: -1,
	currentUserRole: 'Lead', // TODO1 needs to be derived after login
	temp: null,
	overlayEditType: 'none',
	storedUsers: [],
	storedContacts: [],
	storedBPs: [],
	storedProjects: [],
	storedPhases: [],
	storedTaskGroups: [],
	storedTasks: [],
	storedHourLines: [],
	storedSubTasks: [],
	storedCommentLines: []
}

export default (state = defaultState, action) => {
	switch (action.type) {
		case types.SET_DEFAULT:
			return defaultState;
		case types.SET_ATTRIBUTE_BY_OBJ:
			return Object.assign({}, state, action.obj);
		case types.SET_STATE:
			return Object.assign({}, state, action.newState);
		case types.UPDATE_BP:
			// TODO BP edits are not saved to DB
			return Object.assign({}, state, {
				'storedBPs': updateBPInArray(state.storedBPs, action.obj),
				'currentBP': action.obj,
				overlayEditType: 'none'
			});
		case types.ADD_PROJECT:
			return Object.assign({}, state, {
				'storedProjects': [...state.storedProjects, newProject(action.obj)],
				overlayEditType: 'none'
			});
		case types.ADD_PHASE:
			let existing = state.storedTaskGroups.filter(tg => tg === action.obj.uniqueID);
			if (existing.length === 0) { // if the phase doesnt have any task groups Unsorted Tasks will be created
				return Object.assign({}, state, {
					'storedPhases': [...state.storedPhases, newPhase(action.obj)],
					// BUG 'storedTaskGroups': [...state.storedTaskGroups, initialTaskGroup(action.obj, state)],
					overlayEditType: 'none'
				})
			} else {
				return Object.assign({}, state, {
					'storedPhases': [...state.storedPhases, newPhase(action.obj)],
					overlayEditType: 'none'
				})
			}
		case types.ADD_TASK_GROUP:
			return Object.assign({}, state, {
				'storedTaskGroups': [...state.storedTaskGroups, newTaskGroup(action.obj)],
				overlayEditType: 'none'
			})
		default:
			return state;
	}
}

const newProject = (obj) => {
	return obj;
}

const newPhase = (obj) => {
	return obj;
}

const newTaskGroup = (obj) => {
	return obj;
}

const initialTaskGroup = (obj, state) => {
	let newTG = {
		uniqueID: makeRandomString(24),
		parentID: obj.uniqueID,
		display: "Unsorted Tasks",
		description: 'These tasks have not been assigned to a task group.',
		phase: obj.display,
		//hourLines: [],
		dueDate: '',
		bp: obj.bp,
		tasks: [],
		status: 'planned',
		assigned: []
	}

	return newTG;
}

function updateBPInArray(arr, action) {
	return arr.map((item) => {
		if (item.uniqueID !== action.uniqueID) {
			return item;
		}
		return {
			...action
		};
	});
}

export const actions = {
	setDefault: () => {
		return { type: types.SET_DEFAULT };
	},
	setAttributeByObj: (obj) => {
		return { type: types.SET_ATTRIBUTE_BY_OBJ, obj };
	},
	setState: (newState) => ({ type: types.SET_STATE, newState }),
	getData: () => {
		console.log('getData started')
		return function (dispatch, getState) {

			const user = cookie.get('currentUser');

			const bpRequest = retrieveAndParse('PM.GetBPs', {});
			const taskRequest = retrieveAndParse('PM.GetTasks', {});
			const projectRequest = retrieveAndParse('PM.GetProjects', {});
			const phaseRequest = retrieveAndParse('PM.GetPhases', {});
			const taskgroupRequest = retrieveAndParse('PM.GetTaskGroups', {});
			const usersRequest = retrieveAndParse('PM.GetAssignableUsers', {});

			bpRequest.then((res) => {
				//console.log(res)
				dispatch(actions.setState({
					storedBPs: res.slice(),
					loading: true
				}))

			})

			taskRequest.then((res) => {

				let formatted = res.slice();
				res.map((row, index) => {
					formatted[index].assigned = row.assigned.split(",").filter(a => Boolean(a));

					formatted[index].window = {
						"xLeft": 40 + (20 * index),
						"yTop": 120 + (40 * index), // NOTE a little bigger than PMWindowHeader height
						"size_w": 600,
						"size_h": 1080,
						"og_size_w": 600,
						"og_size_h": 1080,
						"zIndex": 8000 + index,
					}

				})

				dispatch(actions.setState({
					storedTasks: formatted
				}))
			})

			projectRequest.then((res) => {

				let formatted = res.slice();
				res.map((row, index) => {
					formatted[index].assigned = row.assigned.split(",");
				})

				dispatch(actions.setState({
					storedProjects: formatted
				}))
			})

			phaseRequest.then((res) => {

				let formatted = res.slice();
				res.map((row, index) => {
					formatted[index].assigned = row.assigned.split(",");
					formatted[index].contacts = row.contacts.split(",");
				})

				dispatch(actions.setState({
					storedPhases: formatted
				}))
			})

			taskgroupRequest.then((res) => {
				let formatted = res.slice();
				res.map((row, index) => {
					formatted[index].assigned = row.assigned.split(",");

					if (row.tasks !== null)
						formatted[index].tasks = row.tasks.split(",");

				})

				dispatch(actions.setState({
					storedTaskGroups: formatted
				}))
			})

			usersRequest.then((res) => {
				let formatted = res.slice();

				const uidx = formatted.findIndex(indexOfUser);
				dispatch(actions.setState({
					storedUsers: formatted,
					currentUserIndex: uidx,
					currentUserRole: formatted[uidx].role // BUG after clearing browser data, on first load
				}))
			})

			Promise.all([bpRequest, taskRequest, projectRequest, phaseRequest, taskgroupRequest, usersRequest])
				.then((res) => {
					console.log("getData finished")
					dispatch(actions.setState({
						loading: false
					}))
				})

			function indexOfUser(usr) {
				return usr.uniqueID === user;
			}

		};
	},
	saveNewProject: (obj) => {
		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const user = pmData.currentUser;

			const newPJ = pmData.storedProjects.slice();

			// filter out the element
			let filtered = newPJ.filter(pj => pj.uniqueID !== obj.uniqueID)

			const writeObj = Object.assign({}, obj, {
				type: 'pmProject',
				assigned: [user]
			})

			// element that needs new key
			const temp = Object.assign({}, obj);
			let newIndex = pmData.storedProjects.length - 1;
			const precursor = writePrecursorXMLSingle(writeObj);

			write(precursor).then((res) => {

				temp.key = res.Data.Results[0].Key;
				const changeObj = {
					loading: false,
					'storedProjects': [...filtered, temp],
					currentProj: newIndex
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	updateBP: (obj) => ({ type: types.UPDATE_BP, obj }),
	addProject: (obj) => ({ type: types.ADD_PROJECT, obj }),
	updateProject: (obj) => {
		return function (dispatch, getState) {

			console.log('updateProject');

			const pmData = getState().pmData;
			const newPJ = pmData.storedProjects.slice();

			// filter out the element
			let filtered = newPJ.filter(pj => pj.uniqueID !== obj.uniqueID)

			const writeObj = Object.assign({}, obj, {
				key: obj.key,
				type: 'pmProject',
				assigned: obj.assigned.join(','),
			})

			let newIndex = pmData.storedProjects.length - 1;

			const precursor = writePrecursorXMLSingle(writeObj);
			write(precursor).then((res) => {

				const changeObj = {
					loading: false,
					overlayEditType: 'none',
					'storedProjects': [...filtered, obj],
					currentProj: newIndex
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})

		}
	},
	getContactsForBP: (id) => {
		console.log('getContactsForBP')
		return function (dispatch, getState) {
			const pmData = getState().pmData;
			const readRequest2 = retrieveAndParse('PM.GetContacts', { CardCode: id });
			readRequest2.then((res) => {

				let formatted = res.slice();

				//res.map((row, index) => {
				//	formatted[index].assigned = row.assigned.split(",").filter(a => Boolean(a));
				//})

				dispatch(actions.setState({
					storedContacts: formatted
				}))
			})

		};
	},
	saveBPContact: (obj) => {
		console.log(obj);
		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const newCt = pmData.storedContacts.slice();
			const uid = pmData.currentBP.uniqueID

			console.log(uid);

			// filter out the element
			let filtered = newCt.filter(ct => ct.uniqueID !== obj.uniqueID)

			// element that needs new key
			const temp = Object.assign({}, obj)

			const writeObj = {
				BP: {
					Code: uid,
					Contact: [{
						ID: obj.firstName + ' ' + obj.lastName,
						First: obj.firstName,
						Last: obj.lastName,
						Email: obj.email,
						Phone1: obj.phone1,
						Position: obj.role,
						Remarks1: obj.notes,
						Active: 'Y' // TODO build up feature
					}],
				}
			}

			write(writeObj).then((res) => {
				console.log(res);
				// apply key to temp
				temp.key = res.Data.Results[0].Key;
				temp.name = obj.firstName + ' ' + obj.lastName;

				const changeObj = {
					loading: false,
					'storedContacts': [...filtered, temp],
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	addPhase: (obj) => ({ type: types.ADD_PHASE, obj }),
	updatePhase: (obj) => {
		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const newPH = pmData.storedPhases.slice();

			// filter out the element
			let filtered = newPH.filter(tg => tg.uniqueID !== obj.uniqueID)

			const writeObj = Object.assign({}, obj, {
				key: obj.key,
				type: 'pmPhase',
				assigned: obj.assigned.join(','),
				contacts: obj.contacts.join(',')
			})

			let newIndex = pmData.storedProjects.length - 1;

			const precursor = writePrecursorXMLSingle(writeObj);
			write(precursor).then((res) => {

				const changeObj = {
					loading: false,
					overlayEditType: 'none',
					'storedPhases': [...filtered, obj],
					currentPhase: newIndex
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	savePhase: (obj) => {
		return function (dispatch) {

			const writeObj = Object.assign({}, obj, {
				type: 'pmPhase'
			})
			const precursor = writePrecursorXMLSingle(writeObj);
			write(precursor).then((res) => {
				const changeObj = {
					loading: false,
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	addTaskGroup: (obj) => {
		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const newTG = pmData.storedTaskGroups.slice();

			// filter out the element
			let filtered = newTG.filter(tg => tg.uniqueID !== obj.parentID)

			// element that needs new key
			const temp = Object.assign({}, obj)

			const writeObj = Object.assign({}, obj, {
				type: 'pmTaskGroup'
			})

			const precursor = writePrecursorXMLSingle(writeObj);
			write(precursor).then((res) => {

				// apply key to temp
				temp.key = res.Data.Results[0].Key;

				const changeObj = {
					loading: false,
					'storedTaskGroups': [...filtered, temp],
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	updateTaskGroup: (obj) => {
		console.log("updateTaskGroup")
		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const newTG = pmData.storedTaskGroups.slice();

			// filter out the element
			let filtered = newTG.filter(tg => tg.uniqueID !== obj.uniqueID)

			const writeObj = Object.assign({}, obj, {
				key: obj.key,
				type: 'pmTaskGroup',
				tasks: obj.tasks.join(',')
			})

			const precursor = writePrecursorXMLSingle(writeObj);
			write(precursor).then((res) => {
				console.log(res);

				const changeObj = {
					loading: false,
					'storedTaskGroups': [...filtered, obj],
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	saveTaskGroup: (obj) => {
		return function (dispatch) {

			const writeObj = Object.assign({}, obj, {
				type: 'pmTaskGroup'
			})
			const precursor = writePrecursorXMLSingle(writeObj);
			write(precursor).then((res) => {
				const changeObj = {
					loading: false,
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	addTask: (obj) => {
		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const newTG = pmData.storedTaskGroups.slice();
			const newTasks = pmData.storedTasks.slice();

			// filter out the element
			let filtered = newTG.filter(tg => tg.uniqueID !== obj.parentID)

			// taskGroup that needs task added
			let found = newTG.findIndex(indexOfTG);
			const tempTG = Object.assign({}, newTG[found])

			if (tempTG.tasks === null) {
				tempTG.tasks = [obj.uniqueID];
			} else {
				tempTG.tasks.push(obj.uniqueID);
			}

			// task that needs new key
			const temp = Object.assign({}, obj)

			const writeObj = Object.assign({}, temp, {
				type: 'pmTask'
			})

			const precursor = writePrecursorXMLSingle(writeObj);
			write(precursor).then((res) => {

				// apply key to temp
				temp.key = res.Data.Results[0].Key;

				const changeObj = {
					loading: false,
					overlayEditType: 'none',
					'storedTasks': [...newTasks, temp],
				}

				dispatch(actions.setAttributeByObj(changeObj));
				dispatch(actions.updateTaskGroup(tempTG))
			})

			function indexOfTG(element) {
				return element.uniqueID == obj.parentID;
			}
		}
	},
	updateTask: (obj) => {
		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const newTask = pmData.storedTasks.slice();

			// filter out the element
			let filtered = newTask.filter(hl => hl.uniqueID !== obj.uniqueID)

			const writeObj = Object.assign({}, obj, {
				key: obj.key,
				type: 'pmTask',
				assigned: obj.assigned.join(',')
			})
			const precursor = writePrecursorXMLSingle(writeObj);
			write(precursor).then((res) => {
				const changeObj = {
					storedTasks: [...filtered, obj],
					temp: obj,
					loading: false,
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	saveNewTask: (obj) => {
		return function (dispatch) {

			const writeObj = Object.assign({}, obj, {
				type: 'pmTask'
			})
			const precursor = writePrecursorXMLSingle(writeObj);
			write(precursor).then((res) => {
				const changeObj = {
					loading: false,
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	getHourLines: (pid) => {
		return function (dispatch, getState) {

			const readRequest = retrieveAndParse('PM.GetHourLines', { ParentID: pid });
			readRequest.then((res) => {
				//console.log(res);
				let formatted = res.slice();

				dispatch(actions.setState({
					storedHourLines: formatted
				}))
			})

		};
	},
	saveHourLines: (obj) => {
		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const user = pmData.currentUser;

			const writeObj = Object.assign({}, obj, {
				type: 'pmHourLine',
			})
			const precursor = writePrecursorXMLSingle(writeObj);

			write(precursor).then((res) => {
				const changeObj = {
					loading: false,
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	removeHourLine: (obj) => {
		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const newHL = pmData.storedHourLines.slice();

			// filter out the element
			let filtered = newHL.filter(hl => hl.uniqueID !== obj.uniqueID)

			const writeObj = Object.assign({}, obj, {
				key: obj.key,
				type: 'pmHourLine'
			})

			const precursor = writePrecursorXMLSingle(writeObj);
			write(precursor).then((res) => {

				const changeObj = {
					loading: false,
					storedHourLines: [...filtered],
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	updateHourLine: (obj) => {

		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const newHL = pmData.storedHourLines.slice();

			// filter out the element
			let filtered = newHL.filter(hl => hl.uniqueID !== obj.uniqueID)

			const writeObj = Object.assign({}, obj, {
				key: obj.key,
				type: 'pmHourLine'
			})

			const precursor = writePrecursorXMLSingle(writeObj);
			write(precursor).then((res) => {

				const changeObj = {
					loading: false,
					storedHourLines: [...filtered, obj],
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	getSubTasks: (pid) => {
		return function (dispatch, getState) {

			const readRequest = retrieveAndParse('PM.GetSubTasks', { ParentID: pid });
			readRequest.then((res) => {
				//console.log(res);
				let formatted = res.slice();


				// update int value to bool
				res.map((row, index) => {
					formatted[index].checked = row.checked === 1 ? true : false;
				})

				dispatch(actions.setState({
					storedSubTasks: formatted
				}))
			})

		};
	},
	saveSubTask: (obj) => {
		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const user = pmData.currentUser;

			// saved bool as int
			let newObj = Object.assign({}, obj);
			newObj.checked = newObj.checked ? 1 : 0;

			const writeObj = Object.assign({}, newObj, {
				type: 'pmSubTask',
			})
			const precursor = writePrecursorXMLSingle(writeObj);

			write(precursor).then((res) => {
				const changeObj = {
					loading: false,
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	removeSubTask: (obj) => {
		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const newST = pmData.storedSubTasks.slice();

			// filter out the element
			let filtered = newST.filter(st => st.uniqueID !== obj.uniqueID)

			const writeObj = Object.assign({}, obj, {
				key: obj.key,
				type: 'pmSubTask'
			})

			const precursor = writePrecursorXMLSingle(writeObj);
			write(precursor).then((res) => {

				const changeObj = {
					loading: false,
					storedSubTasks: [...filtered],
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	updateSubTask: (obj) => {
		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const newST = pmData.storedSubTasks.slice();

			// filter out the element
			let filtered = newST.filter(hl => hl.uniqueID !== obj.uniqueID)

			// saved bool as int
			let newObj = Object.assign({}, obj);
			newObj.checked = newObj.checked ? 1 : 0;

			const writeObj = Object.assign({}, newObj, {
				key: obj.key,
				type: 'pmSubTask'
			})

			const precursor = writePrecursorXMLSingle(writeObj);
			write(precursor).then((res) => {

				const changeObj = {
					loading: false,
					storedSubTasks: [...filtered, obj],
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	getComments: (pid) => {
		return function (dispatch, getState) {

			const readRequest = retrieveAndParse('PM.GetComments', { ParentID: pid });
			readRequest.then((res) => {
				//console.log(res);
				let formatted = res.slice();


				// REF update something??
				//res.map((row, index) => {
				//	formatted[index].value = newValue
				//})

				dispatch(actions.setState({
					storedCommentLines: formatted
				}))
			})

		};
	},
	saveComment: (obj) => {
		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const newCL = pmData.storedCommentLines.slice();

			// task that needs new key
			const temp = Object.assign({}, obj)

			const writeObj = Object.assign({}, obj, {
				type: 'pmComment',
			})
			const precursor = writePrecursorXMLSingle(writeObj);

			write(precursor).then((res) => {

				// apply key to temp
				temp.key = res.Data.Results[0].Key;

				const changeObj = {
					loading: false,
					storedCommentLines: [...newCL, temp],
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	updateComment: (obj) => {
		return function (dispatch, getState) {

			const pmData = getState().pmData;
			const newCL = pmData.storedCommentLines.slice();

			// filter out the element
			let filtered = newCL.filter(hl => hl.uniqueID !== obj.uniqueID)

			const writeObj = Object.assign({}, obj, {
				key: obj.key,
				type: 'pmComment',
			})
			const precursor = writePrecursorXMLSingle(writeObj);

			write(precursor).then((res) => {
				const changeObj = {
					loading: false,
					storedCommentLines: [...filtered, obj],
				}

				dispatch(actions.setAttributeByObj(changeObj));
			})
		}
	},
	getInvoice: (doc) => {
		return function (dispatch, getState) {

			let dummy = {
				invoiceEntry: doc,
				docTotal: 999,
				paidToDate: 555
			}

			dispatch(actions.setState({
				currentInvoice: dummy // TODO remove
			}))

			const readRequest = retrieveAndParse('PM.GetInvoice', { DocEntry: doc });
			readRequest.then((res) => {
				//console.log(res);
				let formatted = res.slice();
				dispatch(actions.setState({
					currentInvoice: formatted
				}))
			})

		};
	},
}


// WEBPACK FOOTER //
// ./src/redux/pm/pmData.js